import React, { forwardRef } from 'react'
import { FEATURE_UC_IN_WEBREGISTER_POPOVER } from '../../../constants'
import { getFeatureFromCache } from '../../../util/feature-cache'
import {
  CustomerSearchProps,
  CustomerSearch as CustomerSearchUnified,
} from './CustomerSearch'
import { CustomerSearchLegacy } from './CustomerSearchLegacy'

export const CustomerSearch = forwardRef<
  React.ElementRef<typeof CustomerSearchLegacy>,
  CustomerSearchProps
>((props, ref) => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_POPOVER
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <CustomerSearchUnified {...props} />
  ) : (
    <CustomerSearchLegacy ref={ref} {...props} />
  )
})

export type { CustomerSearchProps }
